import { Component, OnInit } from '@angular/core';
import{ AppService } from '../app.service';
import { environment } from "src/environments/environment";
import { Router} from "@angular/router";

declare var gtag;
declare var fbq;

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.css']
})
export class TestimonialsComponent implements OnInit {

  constructor(private service:AppService,private router: Router) { }
  testimonialList=[]

  ngOnInit() { 
    if(environment.production){
    this.service.sendEvents("CompleteTestimonials", "testimonials", "Testimonials");

    fbq('track', "CompleteTestimonials" , {
      content_type: "testimonials",
      content_title: this.router.url,
    });
  }

    this.service.setTitle('Our Customer Testimonials and Reviews | Propira');
    this.service.setMetaTags({ property: "og:title", content: 'Our Customer Testimonials and Reviews | Propira ' });
    this.service.setMetaTags({ name: "keywords", content: 'Customer Reviews, Client testimonials, Success Stories of Propira, Honest Testimonial, Testimonials of Real Estate Services, Testimonials of Indian Property Portal' });
    this.service.setMetaTags({ name: "description", content: 'Testimonials are a great evidence of good service, read honest reviews by our customers and know about their experience with Propira. ' });
    this.service.setMetaTags({ property: "og:description", content: 'Testimonials are a great evidence of good service, read honest reviews by our customers and know about their experience with Propira.'});

    this.service.get('/testimonialList').subscribe(
      (data:any)=>{
        if(data[0].error=='0'){
          this.testimonialList=data[0].result;
        }  
      },error=>{ 
        console.log('in error');
      }
    )
  }

}
